export default __webpack_public_path__ + "static/media/resume.7db8d247.jpeg";